export const POPULATE_CREDENTIAL_FROM_ATTRIBUTE_PROPERTY_ID = '330';